import React from 'react';
import { ConfirmationModal } from '../../ui/ConfirmationModal';
import type { DeleteColumnModalState } from '../../../types/table';

export interface DeleteColumnModalProps {
  modalState: DeleteColumnModalState;
  isDeleting?: boolean;
  onConfirm: (columnName: string, columnKey: string) => void;
  onClose: () => void;
}

/**
 * Confirmation modal for deleting a column
 */
export const DeleteColumnModal: React.FC<DeleteColumnModalProps> = ({
  modalState,
  isDeleting = false,
  onConfirm,
  onClose,
}) => {
  if (!modalState.show) return null;

  return (
    <ConfirmationModal
      isOpen={modalState.show}
      onClose={onClose}
      onConfirm={() => onConfirm(modalState.columnName, modalState.columnKey)}
      title="Delete Column"
      message={`Are you sure you want to delete "${modalState.columnName}"? This action cannot be undone.`}
      confirmText="Delete"
      cancelText="Cancel"
      variant="danger"
      isLoading={isDeleting}
    />
  );
};

DeleteColumnModal.displayName = 'DeleteColumnModal';
